import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { tblCoreUser } from './_models/app-models';


@Injectable({
  providedIn: 'root'
})
export class SessionDetailService {
  coreUserInfo = new BehaviorSubject<tblCoreUser>(null as any);

  setCoreUser(data) {
    this.coreUserInfo.next(data);
  }

  getCoreUser(): Observable<any> {
    return this.coreUserInfo.asObservable();
  }
}
